import React from 'react';

export const Header = () => {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-4xl mx-auto px-4 py-5 grid grid-cols-3 items-center">
        <div>
          <img 
            src="/logo-atu.png" 
            alt="ATU Logo" 
            className="h-13 w-auto object-contain"
          />
        </div>
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-wide bg-gradient-to-r from-blue-700 to-blue-900 bg-clip-text text-transparent drop-shadow-sm">AURA</h1>
          <p className="text-sm text-gray-600">Tu entrevistadora simulada</p>
        </div>
        <div></div>
      </div>
    </header>
  );
};
